(self["webpackChunkpop_and_bottle"] = self["webpackChunkpop_and_bottle"] || []).push([[216],{

/***/ 677:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ app),
/* harmony export */   setGlobalConfig: () => (/* binding */ setGlobalConfig),
/* harmony export */   setGlobalVariables: () => (/* binding */ setGlobalVariables)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utilities_functions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(363);



// import { formatMoney } from 'os-utilities'

// import 'os-utilities/plugins'
// import { toggleScroll } from 'os-utilties'

function app(container = document) {
  // console.log('formatMoney', formatMoney)
  initGlobalUtilities(container)
  initFileRouter(container)
}

/*
* TODO: 
  - define folder structure / file structure and what constitutes the different types of files.
  - Add comments
*/

// Creates a global config object with useful element selectors, theme data, etc.
function setGlobalConfig(container = document) {
  window.config = {
    classes: {
      active: 'tw-on',
      loading: 'tw-loading',
      error: 'tw-error',
      unavailable: 'tw-oos',
    },
    container,
    // screens: {}
  }
}

function setGlobalVariables(container) {
  jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('load resize', function () {
    if ((0,_utilities_functions__WEBPACK_IMPORTED_MODULE_1__.elementsExist)([jquery__WEBPACK_IMPORTED_MODULE_0___default()('.section-header')])) {
      window.config.navHeight = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.section-header').outerHeight()
      document.body.style.setProperty('--nav-height', `${window.config.navHeight}px`)
    }

    if ((0,_utilities_functions__WEBPACK_IMPORTED_MODULE_1__.elementsExist)([jquery__WEBPACK_IMPORTED_MODULE_0___default()('.section-announcement-bar')])) {
      window.config.barHeight = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.section-announcement-bar').outerHeight()
      document.body.style.setProperty('--bar-height', `${window.config.barHeight}px`)
    }

    window.config.foldHeight = `calc(100vh - ${window.config.navHeight || 0}px - ${window.config.barHeight || 0}px)`
    document.body.style.setProperty('--fold-height', `${window.config.foldHeight}`)
  })
}

function initGlobalUtilities(container) {
  const globalUtilities = [
    { selector: '[class*="reveal"]', fileName: 'reveal' },
    { selector: '.evm-wscontainer button.evm-ws__cart-submit', fileName: 'wiser-interactions' },
  ]

  globalUtilities.forEach(({ selector, fileName }) => {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(container).watchFor(selector, ($elements) =>
      $elements.each(function () {
        __webpack_require__(182)(`./${fileName}`)
          .then(({ default: utility }) => {
            utility({ wrapper: this })
          })
          .catch((error) => {
            console.warn(`Error importing "~/utilities/${fileName}.js":`, error)
          })
      })
    )
  })
}

function initFileRouter(container) {
  const watchForSelectors = [
    { path: 'utilities', selector: 'utility' },
    { path: 'snippets', selector: 'snippet' },
    { path: 'components', selector: 'component' },
    { path: 'sections', selector: 'section' },
    { path: 'templates', selector: 'template' },
  ]

  watchForSelectors.forEach(({ path, selector }) => {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(container).watchFor(`[data-${selector}]`, ($elements) => {
      $elements.each(function () {
        const fileHandle = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data(selector)

        __webpack_require__(996)(`./${path}/${fileHandle}`)
          .then(({ default: defaultFunction }) => {
            defaultFunction({ wrapper: this })
          })
          .catch((error) => {
            console.warn(`Error importing "~/${path}/${fileHandle}.js":`, error)
          })
      })
    })
  })
}


/***/ }),

/***/ 182:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var map = {
	"./functions": [
		363
	],
	"./functions.js": [
		363
	],
	"./inline-toggle": [
		722,
		341
	],
	"./inline-toggle.js": [
		722,
		341
	],
	"./link-to": [
		740,
		740
	],
	"./link-to.js": [
		740,
		740
	],
	"./password-toggle": [
		2,
		2
	],
	"./password-toggle.js": [
		2,
		2
	],
	"./plugins": [
		118
	],
	"./plugins.js": [
		118
	],
	"./reveal": [
		93,
		93
	],
	"./reveal.js": [
		93,
		93
	],
	"./scroll-toggle": [
		802,
		802
	],
	"./scroll-toggle.js": [
		802,
		802
	],
	"./section-nav": [
		493,
		493
	],
	"./section-nav.js": [
		493,
		493
	],
	"./wiser-interactions": [
		36,
		36
	],
	"./wiser-interactions.js": [
		36,
		36
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 182;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 996:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var map = {
	"./app/": [
		677,
		9
	],
	"./app/index": [
		677,
		9
	],
	"./app/index.js": [
		677,
		9
	],
	"./components/accordion": [
		548,
		9,
		548
	],
	"./components/accordion.js": [
		548,
		9,
		548
	],
	"./components/address-form": [
		913,
		9,
		913
	],
	"./components/address-form.js": [
		913,
		9,
		913
	],
	"./components/global/overlay": [
		908,
		9,
		908
	],
	"./components/global/overlay.js": [
		908,
		9,
		908
	],
	"./components/global/slide-cart": [
		998,
		9,
		998
	],
	"./components/global/slide-cart.js": [
		998,
		9,
		998
	],
	"./components/marquee": [
		150,
		9,
		150
	],
	"./components/marquee.js": [
		150,
		9,
		150
	],
	"./components/navbar": [
		894,
		9,
		894
	],
	"./components/navbar.js": [
		894,
		9,
		894
	],
	"./components/predictive-search": [
		830,
		9,
		830
	],
	"./components/predictive-search.js": [
		830,
		9,
		830
	],
	"./components/quantity-box": [
		649,
		9,
		649
	],
	"./components/quantity-box.js": [
		649,
		9,
		649
	],
	"./components/sc-buy-panel": [
		444,
		9,
		444
	],
	"./components/sc-buy-panel.js": [
		444,
		9,
		444
	],
	"./components/slick-slider": [
		210,
		9,
		125,
		210
	],
	"./components/slick-slider.js": [
		210,
		9,
		125,
		210
	],
	"./components/subscribe-options": [
		13,
		9,
		891,
		13
	],
	"./components/subscribe-options.js": [
		13,
		9,
		891,
		13
	],
	"./components/swiper": [
		524,
		9,
		732,
		524
	],
	"./components/swiper.js": [
		524,
		9,
		732,
		524
	],
	"./components/video-player": [
		143,
		9,
		143
	],
	"./components/video-player.js": [
		143,
		9,
		143
	],
	"./elements/": [
		659,
		7,
		659
	],
	"./elements/index": [
		659,
		7,
		659
	],
	"./elements/index.js": [
		659,
		7,
		659
	],
	"./pages/": [
		422,
		9,
		422
	],
	"./pages/customerAddresses": [
		942,
		9,
		942
	],
	"./pages/customerAddresses.js": [
		942,
		9,
		942
	],
	"./pages/index": [
		422,
		9,
		422
	],
	"./pages/index.js": [
		422,
		9,
		422
	],
	"./sections/product-image-slider": [
		587,
		9,
		732,
		587
	],
	"./sections/product-image-slider.js": [
		587,
		9,
		732,
		587
	],
	"./sections/product-related": [
		839,
		9,
		839
	],
	"./sections/product-related.js": [
		839,
		9,
		839
	],
	"./snippets/account-confirmation-message": [
		763,
		9,
		763
	],
	"./snippets/account-confirmation-message.js": [
		763,
		9,
		763
	],
	"./snippets/billboard": [
		775,
		9,
		775
	],
	"./snippets/billboard.js": [
		775,
		9,
		775
	],
	"./snippets/greenspark-cart-widget": [
		341,
		9,
		722
	],
	"./snippets/greenspark-cart-widget.js": [
		341,
		9,
		722
	],
	"./snippets/overlay": [
		892,
		9,
		892
	],
	"./snippets/overlay.js": [
		892,
		9,
		892
	],
	"./snippets/product-atc": [
		656,
		9,
		656
	],
	"./snippets/product-atc.js": [
		656,
		9,
		656
	],
	"./snippets/product-options": [
		912,
		9,
		912
	],
	"./snippets/product-options.js": [
		912,
		9,
		912
	],
	"./snippets/product-price": [
		783,
		9,
		783
	],
	"./snippets/product-price.js": [
		783,
		9,
		783
	],
	"./snippets/sticky-nav": [
		537,
		9,
		537
	],
	"./snippets/sticky-nav.js": [
		537,
		9,
		537
	],
	"./templates/product": [
		706,
		9,
		706
	],
	"./templates/product.js": [
		706,
		9,
		706
	],
	"./utilities/functions": [
		363,
		9
	],
	"./utilities/functions.js": [
		363,
		9
	],
	"./utilities/inline-toggle": [
		722,
		9,
		341
	],
	"./utilities/inline-toggle.js": [
		722,
		9,
		341
	],
	"./utilities/link-to": [
		740,
		9,
		740
	],
	"./utilities/link-to.js": [
		740,
		9,
		740
	],
	"./utilities/password-toggle": [
		2,
		9,
		2
	],
	"./utilities/password-toggle.js": [
		2,
		9,
		2
	],
	"./utilities/plugins": [
		118,
		9
	],
	"./utilities/plugins.js": [
		118,
		9
	],
	"./utilities/reveal": [
		93,
		9,
		93
	],
	"./utilities/reveal.js": [
		93,
		9,
		93
	],
	"./utilities/scroll-toggle": [
		802,
		9,
		802
	],
	"./utilities/scroll-toggle.js": [
		802,
		9,
		802
	],
	"./utilities/section-nav": [
		493,
		9,
		493
	],
	"./utilities/section-nav.js": [
		493,
		9,
		493
	],
	"./utilities/wiser-interactions": [
		36,
		9,
		36
	],
	"./utilities/wiser-interactions.js": [
		36,
		9,
		36
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 996;
module.exports = webpackAsyncContext;

/***/ })

}]);